import { Component } from '@angular/core';
import { DialogRef } from '@ds/ng-wt-dialog';

@Component({
  selector: 'ds-about',
  templateUrl: './about.component.html',
  styleUrl: './about.component.scss'
})
export class AboutComponent {

  constructor(private ref: DialogRef){}

  onClose() {
    this.ref.close();
  }
}
